export default "__VITE_ASSET__Bq62VO2J__"